import { FC } from 'react';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { Text } from 'roo-ui/components';

const ARROW_HEIGHT = '8px';
const BACKGROUND_COLOR = themeGet('colors.lightOrange');

const ArrowUp = styled('div')`
  width: 0;
  height: 0;
  border-left: ${ARROW_HEIGHT} solid transparent;
  border-right: ${ARROW_HEIGHT} solid transparent;
  border-bottom: ${ARROW_HEIGHT} solid ${BACKGROUND_COLOR};
  margin-left: ${themeGet('space.4')};
`;
ArrowUp.displayName = 'ArrowUp';

const AlertText = styled(Text)`
  background-color: ${BACKGROUND_COLOR};
  border-radius: ${themeGet('radii.default')};
  padding: ${themeGet('space.2')};
  font-size: ${themeGet('fontSizes.sm')};
  color: ${themeGet('colors.greys.charcoal')};
  text-transform: none;
`;
AlertText.displayName = 'AlertText';

const UpdateCreditCardAlert: FC = () => (
  <>
    <ArrowUp />
    <AlertText as="div">We are unable to process the final payment. Please update credit card details</AlertText>
  </>
);

export default UpdateCreditCardAlert;
